import { useParams, usePathname, useSearchParams } from "next/navigation";
import { routes } from "~/routes";

export const useLogoutRedirect = () => {
	const pathname = usePathname();
	const params = useParams();
	const search = useSearchParams().toString();
	const hasLocationContext = ["locationIdentifier", "locationLookupId", "lookup"].some(
		(key) => typeof params[key] === "string",
	);
	return hasLocationContext
		? routes.logout({ redirectTo: search ? `${pathname}?${search}` : pathname })
		: routes.logout();
};
